import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Container, Progress } from 'reactstrap';
import { mind_pattern_sections } from '../../../core/constants'
import { Checkbox } from '../common'
import { Link, useNavigate, useLocation } from 'react-router-dom';

const AssessmentPartOne = (props) => {
  const { hanndleNext, hanndlePrev, questions, current_step, current_list_response } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const [current_value, setCurrentValue] = useState(null);

  useEffect(() => {
    const newCurrentValue = current_list_response.find(item => item.number === current_step)?.value || null;
    
    setCurrentValue(newCurrentValue);
  }, [current_step, current_list_response]);

  console.log('current_value', current_value, 'current_list_response', current_list_response, 'current_step', current_step)

  const toggle = (value) => {
    setCurrentValue(value)
  };

  const question_key = current_step-1
  let next = mind_pattern_sections.READY_PART_TWO

  if ( questions.get(current_step) ){
    next = mind_pattern_sections.ASSESSMENT
  }

  const select_option = new Set([current_value])

  const data = questions.get(question_key);

  const handleClose = () => {
    if (location.pathname === '/mind-patterns') {
      window.location.reload();
    } else {
      navigate('/mind-patterns');
    }
  };

  return (
    <div className='w-100 h-100'>
    <Container fluid="md" className="content-questions w-100 h-100 p-0">
      <div className='pt-md-3 px-md-3 rounded border-md h-100'>

        <div className="d-flex justify-content-between align-items-center mb-4">
          <Progress value={current_step} max={questions.size} className='flex-fill progress-sm' />
          <div className="paginador mx-3 small font-weight-semibold">{current_step}/{questions.size}</div>
          <div className="d-flex justify-content-center align-items-center">
            <Link className="icon-close" to="/mind-patterns" onClick={handleClose}></Link>
          </div>
        </div>
        <p className='text-muted font-italic text-center mb-4'>Tap on the option that is most true for you and then tap “next” to go on to the next question</p>

        <div className='mb-5'>
          <div onClick={() => toggle(data.value1)} className='border-bottom'>
            <Checkbox handleCheckboxChange={toggle} select_option={select_option} label={data.description1} value={data.value1} type={'radio'} />
          </div>

          <div onClick={() => toggle(data.value2)} className='border-bottom'>
            <Checkbox handleCheckboxChange={toggle} select_option={select_option} label={data.description2} value={data.value2} type={'radio'}/>
          </div>

          <div onClick={() => toggle(data.value3)} className='border-bottom'>
            <Checkbox handleCheckboxChange={toggle} select_option={select_option} label={data.description3} value={data.value3} type={'radio'}/>
          </div>
        </div>

        <div className='text-center mb-3'>
          <button onClick={() => hanndlePrev(data, current_value, mind_pattern_sections.ASSESSMENT)} className="btn btn-outline-green-light btn-sm px-3 mx-2" disabled={current_step === 1}> 
            <i className="mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" fill="currentColor" viewBox="0 0 10.9 9.2" style={{ marginBottom: '2px'}}>
                <path d="M10.9,4.6c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2h-8l2.8,2.8c0.1,0.1,0.2,0.3,0.2,0.5
                c0,0.2-0.1,0.3-0.2,0.5C4.9,9.1,4.8,9.2,4.6,9.2S4.3,9.1,4.1,9L0.2,5.1C0.1,5,0.1,4.9,0.1,4.8C0,4.8,0,4.7,0,4.6s0-0.2,0.1-0.3
                c0-0.1,0.1-0.2,0.1-0.2l3.9-3.9c0.1-0.1,0.1-0.1,0.2-0.1C4.4,0,4.5,0,4.6,0c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.2,0.1
                c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.2L2.2,3.9h8c0.2,0,0.3,0.1,0.5,0.2
                C10.9,4.3,10.9,4.4,10.9,4.6z"/>
              </svg>
            </i>
            Previous
          </button>
          <button onClick={ () => hanndleNext(next, data, current_value, mind_pattern_sections.ASSESSMENT )} className="btn btn-outline-green-light btn-sm px-3 mx-2" disabled={ !current_value }>
            Next
            <i className="ml-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" fill="currentColor" viewBox="0 0 10.94 9.19" style={{ marginBottom: '2px'}}>
                  <path d="M10.75,5.06l-3.94,3.94c-.12,.12-.29,.19-.46,.19s-.34-.07-.46-.19c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46l2.82-2.82H.66c-.17,0-.34-.07-.46-.19-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46c.12-.12,.29-.19,.46-.19H8.7L5.88,1.12c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46,.29-.19,.46-.19,.34,.07,.46,.19l3.94,3.94c.06,.06,.11,.13,.14,.21s.05,.17,.05,.25c0,.09-.02,.17-.05,.25-.03,.08-.08,.15-.14,.21Z"/>
              </svg>
            </i>
          </button>
        </div>
      </div>
    </Container>
    </div>
  )

}

const mapStateToProps = (state, props) => {
  return { };
};

const mapDispatchToProps = {
};

export default  connect(
    mapStateToProps,
    mapDispatchToProps
)(AssessmentPartOne)
